// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './layout/Navbar';
import Home from './pages/Home';
import Post from './pages/Post';
import About from './pages/About';
import Footer from './layout/Footer'; // Import Footer

const App = () => {
  return (
    <Router>
      <Navbar />
      <main> {/* This is the content container */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/post/:id" element={<Post />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </main>
      <Footer /> {/* Footer placed below content */}
    </Router>
  );
};

export default App;
